module.exports = __webpack_public_path__ + "static/media/mstile-310x150.b0b366d9.png";